module.exports = __webpack_public_path__ + "static/media/UserLogo.60e7d34a.svg";